<!-- 个人经历 -->
<template>
  <div class="experience">
    <h1 class="application-title">个人经历</h1>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="226">
      <div class="experience-form">
        <div class="dis-96">
          <div class="application-order-title dis-36">
            1. Awards, distinctions, honors
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.awards"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeAward(index)"></div>
            <FormItem label="Award and Reason"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. X scholarship for academic achievement"></Input>
            </FormItem>
            <FormItem label="Year"
                      prop="name">
              <DatePicker type="date"
                          placeholder="Select date"
                          v-model="item.description"
                          style="width:100%;"></DatePicker>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addAward">添加更多 Award</div>
        </div>
        <div class="dis-96">
          <div class="application-order-title dis-36">
            2. Interests/Hobbies
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.hobbies"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeHobbie(index)"></div>
            <FormItem label="Hobby"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. Piano, grade 10"></Input>
            </FormItem>
            <FormItem label="Length of time"
                      prop="name">
              <Input v-model="item.description"
                     placeholder="e.g. 5 years"></Input>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addHobbie">添加更多 Hobby</div>
        </div>
        <div class="dis-96">
          <div class="application-order-title dis-36">
            3. Languages other than Chinese and English
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.languages"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeLanguage(index)"></div>
            <FormItem label="Language"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. French"></Input>
            </FormItem>
            <FormItem label="Proficiency"
                      prop="name">
              <Input v-model="item.description"
                     placeholder="e.g. Level of fluency"></Input>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addLanguage">添加更多 Language</div>
        </div>
        <div class="dis-96">
          <div class="application-order-title dis-36">
            4. Places Lived
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.placesLived"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removePlacesLived(index)"></div>
            <FormItem label="Country"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. China"></Input>
            </FormItem>
            <FormItem label="Length"
                      prop="name">
              <Input v-model="item.description"
                     placeholder="e.g. 5 years"></Input>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addPlacesLived">添加更多 Place</div>
        </div>
        <div class="dis-96">
          <div class="application-order-title dis-36">
            5. Numbers of countries and continents travelled
          </div>
          <div class="dis-48">
            <FormItem label="Country"
                      prop="countriesCount">
              <Input v-model="formValidate.countriesCount"
                     placeholder="e.g. 4"></Input>
            </FormItem>
            <FormItem label="Continents"
                      prop="stateCount">
              <Input v-model="formValidate.stateCount"
                     placeholder="e.g. 2"></Input>
            </FormItem>
          </div>
        </div>

        <div class="dis-96">
          <div class="application-order-title dis-36">
            6. Other significant credentials
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.significantCredentials"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeSignificantCredential(index)"></div>
            <FormItem label="Credential"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. CFA level I"></Input>
            </FormItem>
            <FormItem label="Year"
                      prop="name">
              <DatePicker type="date"
                          placeholder="Select date"
                          v-model="item.description"
                          style="width:100%;"></DatePicker>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addSignificantCredential">添加更多 Credential</div>
        </div>

        <div class="dis-96">
          <div class="application-order-title dis-36">
            7. Any other talents not mentioned
          </div>
          <div class="dis-48"
               v-for="(item, index) in formValidate.otherTalent"
               :key="index">
            <div class="delete"
                 v-if="index!=0"
                 @click="removeOtherTalent(index)"></div>
            <FormItem label="Talent"
                      prop="name">
              <Input v-model="item.name"
                     placeholder="e.g. Public speaking with toastmasters"></Input>
            </FormItem>
            <FormItem label="Length of time"
                      prop="name">
              <Input v-model="item.description"
                     placeholder="e.g. 5 years"></Input>
            </FormItem>
          </div>
          <div class="application-order-add"
               @click="addOtherTalent">添加更多 Talent</div>
        </div>
        <div class="dis-96">
          <div class="application-order-title dis-36">
            8.List all activities you have participated in during the past 4 summers
          </div>
          <div class="dis-48">
            <FormItem label="Freshman"
                      prop="name">
              <Input v-model="formValidate.freshman"
                     placeholder="e.g. Summer camp"></Input>
            </FormItem>
            <FormItem label="Sopomore"
                      prop="name">
              <Input v-model="formValidate.sopomore"
                     placeholder="e.g. Summer camp"></Input>
            </FormItem>
            <FormItem label="Junior"
                      prop="name">
              <Input v-model="formValidate.junior"
                     placeholder="e.g. Summer camp"></Input>
            </FormItem>
            <FormItem label="Senior"
                      prop="name">
              <Input v-model="formValidate.senior"
                     placeholder="e.g. Summer camp"></Input>
            </FormItem>
          </div>
        </div>
        <div>
          <div class="application-order-title dis-36">
            9. What are your favorite readings (books, publications, etc.)
          </div>
          <div>
            <FormItem label="Book by author/pulbication"
                      prop="book1">
              <Input v-model="formValidate.book1"
                     placeholder="e.g. A Tale of Two Cities"></Input>
            </FormItem>
          </div>
          <div class="dis-0">
            <FormItem label="Book by author/pulbication"
                      prop="book2">
              <Input v-model="formValidate.book2"
                     placeholder="e.g. A Tale of Two Cities"></Input>
            </FormItem>
          </div>
        </div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryPersonalexp, infoModifyPersonalexp } from '@/api/info'
// tool
import { date2String } from '@/libs/tools'
import { validateNumber } from '@/libs/validator'
export default {
  name: 'application-experience',
  mixins: [isAllowEdit],
  components: {},
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        countriesCount: [{ validator: validateNumber }],
        stateCount: [{ validator: validateNumber }]
      }
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryPersonalexp().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)

        this.$set(this.formValidate, 'awards', data.awards || [{}])
        this.$set(this.formValidate, 'hobbies', data.hobbies || [{}])
        this.$set(this.formValidate, 'languages', data.languages || [{}])
        this.$set(this.formValidate, 'placesLived', data.placesLived || [{}])
        this.$set(this.formValidate, 'significantCredentials', data.significantCredentials || [{}])
        this.$set(this.formValidate, 'otherTalent', data.otherTalent || [{}])
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)

          this.awardDate2String(data.awards)
          infoModifyPersonalexp(data).then(res => {
            this.$router.push({
              name: 'application-intention'
            })
            this.$zlr_message('保存成功', 'success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    },
    addAward () {
      this.formValidate.awards.push({
        name: '',
        description: ''
      })
    },
    removeAward (index) {
      this.formValidate.awards.splice(index, 1)
      this.$zlr_message({
        content: '删除成功',
        time: 1000
      }, 'success')
    },
    awardDate2String (data) {
      data.forEach((item, index) => {
        item.description = date2String(item.description)
      })
    },
    addHobbie () {
      this.formValidate.hobbies.push({
        name: '',
        description: ''
      })
    },
    removeHobbie (index) {
      this.formValidate.hobbies.splice(index, 1)
    },
    addLanguage () {
      this.formValidate.languages.push({
        name: '',
        description: ''
      })
    },
    removeLanguage (index) {
      this.formValidate.languages.splice(index, 1)
    },
    addPlacesLived () {
      this.formValidate.placesLived.push({
        name: '',
        description: ''
      })
    },
    removePlacesLived (index) {
      this.formValidate.placesLived.splice(index, 1)
    },
    addSignificantCredential () {
      this.formValidate.significantCredentials.push({
        name: '',
        description: ''
      })
    },
    removeSignificantCredential (index) {
      this.formValidate.significantCredentials.splice(index, 1)
    },
    addOtherTalent () {
      this.formValidate.otherTalent.push({
        name: '',
        description: ''
      })
    },
    removeOtherTalent (index) {
      this.formValidate.otherTalent.splice(index, 1)
    }

  }
}
</script>
<style lang='less' scoped>
</style>
